import { Controller } from "@hotwired/stimulus"

// Prefills a target input with a value on click
// Usage:
//   <button data-controller="prefill"
//           data-prefill-target-value="#search-input"
//           data-prefill-text-value="Some text"
//           data-action="click->prefill#fill">Use this</button>
export default class extends Controller {
  static values = {
    target: String,
    text: String
  }

  fill() {
    const targetElement = document.querySelector(this.targetValue)
    if (targetElement) {
      targetElement.value = this.textValue
      // Trigger input event so other controllers can react
      targetElement.dispatchEvent(new Event('input', { bubbles: true }))
    }
  }
}
